export { default as MultiSelect } from './MultiSelect'



// WEBPACK FOOTER //
// ./src/components/MultiSelect/index.js